"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EmailAttachmentValidators = _interopRequireDefault(require("customer-data-email/schema/validation/EmailAttachmentValidators"));

var _InteractionWithValidatedAttachmentsComponentConfig = _interopRequireDefault(require("customer-data-communicator/components/wrappers/config/InteractionWithValidatedAttachmentsComponentConfig"));

var _FileUploadOptions = require("customer-data-communicator/lib/attachments/FileUploadOptions");

var EMAIL_FILE_OPTIONS = (0, _FileUploadOptions.getFileUploadOptions)();

var _default = _InteractionWithValidatedAttachmentsComponentConfig.default.set('fileOptions', EMAIL_FILE_OPTIONS).set('validators', _EmailAttachmentValidators.default);

exports.default = _default;
module.exports = exports.default;